import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Button, Container, Typography } from '@mui/material';
import React from 'react';

const HELPIGO_BLUE = '#2563eb';

/**
 * helpigo.app üst şeridine benzer önizleme / demo hatırlatması
 */
export default function HomePreviewBar() {
    return (
        <Box
            sx={{
                pt: { xs: '72px', md: '80px' },
                background: `linear-gradient(90deg, ${HELPIGO_BLUE}08 0%, #99bbe326 50%, ${HELPIGO_BLUE}0d 100%)`,
                borderBottom: '1px solid rgba(37, 99, 235, 0.12)',
            }}
        >
            <Container maxWidth="lg">
                <Box
                    sx={{
                        py: 1.25,
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: { xs: 1, sm: 2 },
                        textAlign: { xs: 'center', sm: 'left' },
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'text.primary' }}>
                        <InfoOutlinedIcon sx={{ fontSize: 20, color: HELPIGO_BLUE, flexShrink: 0 }} />
                        <Typography variant="body2" sx={{ fontWeight: 500, fontSize: { xs: '0.8125rem', sm: '0.875rem' } }}>
                            Canlı ortam için kurulum ve demo planı oluşturun — ekibimiz dakikalar içinde dönüş yapar.
                        </Typography>
                    </Box>
                    <Button
                        size="small"
                        variant="contained"
                        data-tally-open="wMV9kA"
                        data-tally-layout="modal"
                        data-tally-width="400"
                        data-tally-auto-close="0"
                        sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            borderRadius: 999,
                            px: 2.5,
                            py: 0.75,
                            bgcolor: HELPIGO_BLUE,
                            boxShadow: 'none',
                            '&:hover': { bgcolor: '#1d4ed8', boxShadow: '0 4px 14px rgba(37,99,235,0.35)' },
                            flexShrink: 0,
                        }}
                    >
                        Demo talebi
                    </Button>
                </Box>
            </Container>
        </Box>
    );
}
